const locale = require('./reasonModal.i18n.json');

/*@ngInject*/
const ReasonModalController = function ($rootScope, $scope, coreConstant, coreMediator, dateUtil, primaryDropdown, secondaryDropdown, options) {
    $scope.i18n = locale;

    $scope.viewModel = {
        title: options.title,
        cancelButton: _.get( $scope.i18n, 'cancel'),
        okButton: _.get( $scope.i18n, 'confirm'),
        summary: options.summary,
        primaryReasonList: [],
        secondaryReasonList: [],
        selectedPrimaryReason: options.selectedPrimaryReason,
        selectedSecondaryReason: options.selectedSecondaryReason,
        primaryReasonIsOptional: options.primaryReasonIsOptional,
        secondaryDropdownIsOptional: options.secondaryDropdownIsOptional,
        primaryOtherReason: '',
        secondaryOtherReason: '',
        showSecondaryReason: secondaryDropdown !== null,
        secondaryLabel: options.secondaryLabel,
        showPrimaryOtherReason: false,
        showSecondaryOtherReason: false,
        comments: options.comments,
        showDates: options.showDates,
        startDateLabel: options.startDateLabel,
        endDateLabel: options.endDateLabel,
        startDate: null,
        endDate: null,
        timezoneMode: options.timezoneMode
    };

    $scope.onSelectPrimaryReason = function (choice) {
        $scope.viewModel.selectedPrimaryReason = choice;
        $scope.viewModel.showPrimaryOtherReason = choice.value.toLowerCase() === 'other';
        $scope.viewModel.primaryOtherReason = '';
    };

    $scope.onSelectSecondaryReason = function (choice) {
        $scope.viewModel.selectedSecondaryReason = choice;
        $scope.viewModel.showSecondaryOtherReason = choice.value.toLowerCase() === 'other';
        $scope.viewModel.secondaryOtherReason = '';
    };

    $scope.getPrimaryReasonLabel = function () {
        const selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason;
        return selectedPrimaryReason ? selectedPrimaryReason.name : _.get( $scope.i18n, 'defaultPrimaryPrompt');
    };

    $scope.getSecondaryReasonLabel = function () {
        const selectedSecondaryReason = $scope.viewModel.selectedSecondaryReason;
        return selectedSecondaryReason ? selectedSecondaryReason.name : _.get( $scope.i18n, 'defaultSecondaryPrompt');
    };

    $scope.onConfirm = function () {
        var selectedPrimaryReason = '',
            selectedSecondaryReason = $scope.viewModel.selectedSecondaryReason,
            finalDetails,
            dateRangeInputFormat = coreMediator.getPreferenceByName('view.shortDateFormat');

        if ($scope.viewModel.selectedPrimaryReason) {
            if ($scope.viewModel.selectedPrimaryReason.name.toLowerCase() === 'other') {
                selectedPrimaryReason = $scope.viewModel.primaryOtherReason;
            } else {
                selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason.value;
            }
        }

        if (selectedSecondaryReason && selectedSecondaryReason.value) {
            finalDetails = 'Lost to:' + selectedSecondaryReason.value + '; ' + $scope.viewModel.comments;
        } else {
            finalDetails = $scope.viewModel.comments;
        }

        $scope.$close({
            reason: selectedPrimaryReason,
            secondaryReason: selectedSecondaryReason,
            details: $scope.viewModel.comments,
            startDate: $scope.viewModel.startDate,
            endDate: $scope.viewModel.endDate
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    function primaryReasonIsNotSelected() {
        var hasPrimaryReasonSelection = $scope.viewModel.selectedPrimaryReason && $scope.viewModel.selectedPrimaryReason.value,
            primaryOtherReasonIsRequired = $scope.viewModel.showPrimaryOtherReason === true,
            isValidPrimaryOtherReason = primaryOtherReasonIsRequired ? $scope.viewModel.primaryOtherReason.length > 0 : true;

        return !$scope.viewModel.primaryReasonIsOptional && (!hasPrimaryReasonSelection || !isValidPrimaryOtherReason);
    }

    function secondaryReasonIsNotSelected() {
        var hasSecondaryReasonSelection = $scope.viewModel.selectedSecondaryReason && $scope.viewModel.selectedSecondaryReason.value;

        return !$scope.viewModel.secondaryDropdownIsOptional && !hasSecondaryReasonSelection;
    }

    function datesNotSelected() {
        var hasSecondaryReasonSelection = $scope.viewModel.startDate && $scope.viewModel.endDate;

        return $scope.viewModel.showDates && !hasSecondaryReasonSelection;
    }

    $scope.dateRangeUpdated = function (value) {
        $scope.viewModel.startDate = dateUtil.parseDateRangeStartDateToMilliseconds(value);
        $scope.viewModel.endDate = dateUtil.parseDateRangeEndDateToMilliseconds(value);
    };

    $scope.canEnableConfirmButton = function () {
        return !(primaryReasonIsNotSelected() || secondaryReasonIsNotSelected() || datesNotSelected());
    };

    $scope.showCheckMarkForPrimaryReason = function () {
        return !primaryReasonIsNotSelected();
    };

    $scope.showCheckMarkForSecondaryReason = function () {
        return !secondaryReasonIsNotSelected();
    };

    coreMediator.getDynamicDataSetItems(primaryDropdown).then(function (result) {
        $scope.viewModel.primaryReasonList = options.primaryDropdownFilterFunction ? _.filter(result, options.primaryDropdownFilterFunction) : result;
        setReasonFields();
    });

    function setReasonFields() {
        var foundSelectedReason = false;
        if ($scope.viewModel.selectedPrimaryReason.name.toLowerCase() === 'other') {
            $scope.viewModel.showPrimaryOtherReason = true;
            $scope.viewModel.primaryOtherReason = $scope.viewModel.selectedPrimaryReason.value;
        } else {
            _.forEach($scope.viewModel.primaryReasonList, function (reason) {
                if (reason.value === $scope.viewModel.selectedPrimaryReason.value) {
                    foundSelectedReason = true;
                    return false;
                }
            });
        }

        if (!foundSelectedReason && $scope.viewModel.selectedPrimaryReason.ordering === -999) {
            $scope.viewModel.showPrimaryOtherReason = true;
            $scope.viewModel.primaryOtherReason = $scope.viewModel.selectedPrimaryReason.value;
            $scope.viewModel.selectedPrimaryReason.name = 'Other';
        } else {
            $scope.viewModel.selectedPrimaryReason = $scope.viewModel.selectedPrimaryReason ? $scope.viewModel.selectedPrimaryReason : _.get(translations, 'defaultPrimaryPrompt');
        }
    }

    if ($scope.viewModel.showSecondaryReason) {
        coreMediator.getDynamicDataSetItems(secondaryDropdown).then(function (result) {
            $scope.viewModel.secondaryReasonList = options.secondaryDropdownFilterFunction ? _.filter(result, options.secondaryDropdownFilterFunction) : result;
        });
    }

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('reasonModalController', ReasonModalController);
